import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { RewardReferralRole } from '../../../../models/RewardStore';
import { Profile } from '../../../../models/UserStore';
import {
  AppBar,
  SvgIcon,
  WebStoreProductCard,
  WebStoreProductCardProps,
} from '../../../Molecules';

import styles from './WebStoreProductListTemplate.module.css';

export type WebStoreProductListTemplateProps = {
  profile: Profile | undefined | null;
  rewardReferralRole: RewardReferralRole | undefined;
  userRewardReferralCode: string | undefined | null;
  productInfoList: WebStoreProductCardProps[];
  onClickDistributorDetails?: () => void;
};

export const WebStoreProductListTemplate = memo(
  ({
    // profile,
    rewardReferralRole,
    userRewardReferralCode,
    productInfoList,
    onClickDistributorDetails,
  }: WebStoreProductListTemplateProps) => {
    const { t } = useTranslation();
    const [columnCount, setColumnCount] = useState(2);

    useEffect(() => {
      const COLUMN_WIDTH = 200;
      const GAP_WIDTH = 8;

      const handleResize = () => {
        const screenWidth = Math.min(window.innerWidth, 768);
        const availableWidth = screenWidth - 40;
        const maxColumnNum = 5;
        const possibleColumns = Math.floor(
          (availableWidth + GAP_WIDTH) / (COLUMN_WIDTH + GAP_WIDTH),
        );

        const newColumnCount = Math.max(
          2,
          Math.min(maxColumnNum, possibleColumns),
        );
        setColumnCount(newColumnCount);
      };

      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const columns = Array.from({ length: columnCount }, (_, columnIndex) => (
      <div key={columnIndex} className={styles.column}>
        {productInfoList.map((item, index) =>
          index % columnCount === columnIndex ? (
            <WebStoreProductCard key={index} {...item} />
          ) : null,
        )}
      </div>
    ));

    return (
      <div className={styles.productList}>
        <AppBar
          leading={
            <SvgIcon
              name={SVGIconType.WebStoreBasket}
              width={28}
              height={28}
              color="#333"
            />
          }
          title={t('Web Store')}
          withBack={true}
        />
        <div className={styles.userInfoContainer}>
          {/* {profile && (
            <div className={styles.userAvatarContainer}>
              <AvatarNode profile={profile} size={50} />
            </div>
          )} */}
          <div className={styles.horizontalContainer}>
            {/* <div className={styles.userName}>{profile?.name}</div> */}
            {userRewardReferralCode && (
              <div className={styles.distributorId}>
                {`${t(
                  rewardReferralRole === RewardReferralRole.Partner
                    ? 'Partner ID: '
                    : 'Distributor ID: ',
                )} ${userRewardReferralCode}`}
              </div>
            )}
            {onClickDistributorDetails && (
              <div
                className={styles.clickDistributorDetails}
                onClick={onClickDistributorDetails}
              >
                {t(
                  rewardReferralRole === RewardReferralRole.Partner
                    ? 'Partner Details'
                    : 'Distributor Details',
                )}
                <SvgIcon name={SVGIconType.Arrow} width={16} height={16} />
              </div>
            )}
          </div>
        </div>

        <div className={styles.productGrid}>{columns}</div>
      </div>
    );
  },
);
